import React from 'react';
import { Button } from '../../components/ui/button.jsx';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@radix-ui/react-icons';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card.jsx';

export default function NotFoundPage() {
    return (
        <div className="min-h-full min-w-full flex flex-col justify-center items-center">
            <Card className="w-full max-w-md shadow-lg">
                <CardHeader className="text-center space-y-2">
                    <div className="w-20 h-20 mx-auto bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center">
                        <span className="text-4xl font-bold text-gray-400">404</span>
                    </div>
                    <CardTitle className="text-2xl font-bold">Page Not Found</CardTitle>
                    <CardDescription className="text-gray-500 dark:text-gray-400">
                        Oops! The page you're looking for doesn't exist or has been moved.
                    </CardDescription>
                </CardHeader>
                <CardContent className="flex flex-col items-center space-y-4">
                    <p className="text-center text-gray-600 dark:text-gray-300">
                        Let's get you back on track.
                    </p>
                    <Link to="/" className="w-full flex justify-center">
                        <Button variant="default" className="w-full max-w-xs">
                                <ArrowLeftIcon className="mr-2 h-4 w-4" />
                                Back to Home
                        </Button>
                    </Link>
                </CardContent>
            </Card>
        </div>
    );
}
